import { api } from './client';
import type { LoginResponse, RefreshResponse, User } from '@/types';

export interface RegisterRequest {
  email: string;
  password: string;
  displayName: string;
}

export interface LoginRequest {
  email: string;
  password: string;
}

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  newPassword: string;
}

export const authApi = {
  register: (data: RegisterRequest) =>
    api.post<LoginResponse>('/api/auth/register', data),

  login: (data: LoginRequest) =>
    api.post<LoginResponse>('/api/auth/login', data),

  logout: (refreshToken: string) =>
    api.post('/api/auth/logout', { refreshToken }),

  refresh: (refreshToken: string) =>
    api.post<RefreshResponse>('/api/auth/refresh', { refreshToken }),

  forgotPassword: (data: ForgotPasswordRequest) =>
    api.post('/api/auth/forgot-password', data),

  resetPassword: (data: ResetPasswordRequest) =>
    api.post('/api/auth/reset-password', data),

  verifyEmail: (token: string) =>
    api.post('/api/auth/verify-email', { token }),

  me: () =>
    api.get<User>('/api/users/me'),

  updateProfile: (data: Partial<User>) =>
    api.put<User>('/api/users/me', data),
};
